var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPlayerLog = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_logs",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47058",
    "data-name": "Path 47058",
    d: "M297.12,398.819a.628.628,0,0,0,.43.57l3.759,1.24,1.24,3.759a.628.628,0,0,0,1.174.049l4.018-9.416a.628.628,0,0,0-.823-.824l-9.416,4.018a.628.628,0,0,0-.381.6Z",
    transform: "translate(-297.12 -386.819)",
    fill: "#00a1af"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47059",
    "data-name": "Path 47059",
    d: "M307.016,398.971a4.04,4.04,0,1,0-4.04-4.04.47.47,0,1,1-.94,0,4.979,4.979,0,1,1,4.979,4.979h0a.47.47,0,1,1,0-.94Z",
    transform: "translate(-297.183 -386.764)",
    fill: "#00a1af"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47669",
    "data-name": "Path 47669",
    d: "M312.757,389.106a8.109,8.109,0,0,0-5.751-2.383h-.014a8.173,8.173,0,0,0-8.164,8.15.711.711,0,1,0,1.422,0,6.742,6.742,0,1,1,6.742,6.742h-.1l-.009.008a.711.711,0,0,0,.113,1.414,8.164,8.164,0,0,0,5.765-13.931Z",
    transform: "translate(-297.142 -386.723)",
    fill: "#00a1af"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPlayerLog);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_player_log.4be89c6885cb448c004f62e0b9b5d8d0.svg";